<template>
    <header class="masthead text-center text-white d-flex">
        <div class="container my-auto slogan">
            <div class="row">
                <div class="col">
                    <!-- <h3 class="">RE-EVOLUCIÓN 2020</h3> -->
                </div>
            </div>
        </div>
    </header>
</template>

<script>
export default {
  name: 'MainHeader',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.slogan {
    position: relative;
}

.slogan h3 {
    display: none;
    color: #000;
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
    .slogan h3 {
        display: inline-block;
        margin-top: 450px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/vue/components/header/MainHeader.vue